<template>
  <div class="m_bandeau">
    <div
      class="m_bandeau--titre"
      v-html="$root.copy_content.title + $root.copy_content.subtitle"
    />
    <div
      class="m_bandeau--description"
      v-html="$root.copy_content.description"
    />
    <div class="m_bandeau--logo">
      <img
        v-for="logo in $root.copy_content.logos"
        :key="logo.metaFileName"
        :src="
          `${$root.dodoc_url}contenus-statiques-du-site-recits-solidaire-dodoc-fr/${logo.media_filename}`
        "
      />
    </div>
  </div>
</template>
<script>
export default {
  props: {},
  components: {},
  data() {
    return {};
  },
  created() {},
  mounted() {},
  beforeDestroy() {},
  watch: {},
  computed: {},
  methods: {},
};
</script>
<style lang="scss" scoped>
.m_bandeau {
  max-width: 76vh;
  margin: 0 auto;
}

.m_bandeau--titre {
  text-align: center;
  margin-top: 0;
  margin-bottom: calc(var(--spacing) * 2);

  ::v-deep h1 {
    font-size: 2rem;
    font-weight: 900;
    text-transform: uppercase;
  }

  ::v-deep h2 {
    font-weight: 300;
    font-size: 1.4rem;
  }

  ::v-deep {
    h1 + h2 {
      margin-top: -1em;
    }
  }
}

.m_bandeau--description {
  margin-bottom: var(--spacing);
  ::v-deep p {
    margin: 0;
  }
}

.m_bandeau--logo {
  text-align: center;
  margin-bottom: var(--spacing);

  img {
    width: 108px;
    height: 77px;
    margin: 0 auto;
    object-fit: contain;
  }
}
</style>
